import React, { FC, useMemo, useState } from "react";
import { useSetAtom } from "jotai";
import { Icon } from "assets/icons";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import { useClientsState } from "atoms/clientsAtom";
import { useGetClientGroups } from "features/ClientGroups/api";
import { useEditClient } from "features/ClientInfo/api";
import { ClientGroup } from "types";

import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import Radio from "components/Radio/Radio";
import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { BoldText } from "components/BoldText/BoldText";

export const ChangeGroupModal: FC = () => {
  const { clientsState, setClientsState } = useClientsState();
  const [selectedRadio, setSelectedRadio] = useState<string | undefined>(
    clientsState.activeGroupItem?.clientgroupid
  );
  const closeModal = useSetAtom(setModalCloseAtom);

  const { data: clientGroups = [] } = useGetClientGroups({ enabled: false });

  const { mutateAsync: editClientAsync } = useEditClient();

  const filteredClientGroups: ClientGroup[] = useMemo(() => {
    return clientGroups;
  }, [clientGroups]);

  const handleSave = async () => {
    if (selectedRadio) {
      const promises: Promise<any>[] = [];

      clientsState.activeItems.forEach((client) => {
        promises.push(
          editClientAsync({
            clientgroupid: Number(selectedRadio),
            clientid: Number(client.clientid),
          })
        );
      });

      await Promise.all(promises);

      setClientsState((prev) => ({
        ...prev,
        activeItems: [],
        activeItem: null
      }));
    }

    closeModal();
  };

  return (
    <BaseLayout
      width={400}
      height={500}
      header={
        <div className="flex justify-between items-center">
          <BoldText>Выберите группу для перемещения</BoldText>
          <Icon type="close" onClick={closeModal} className="cursor-pointer" />
        </div>
      }
      footer={
        <div className="flex flex-row mt-4 justify-center">
          <Button onClick={closeModal} variant={EButtonVariant.TERTIARY}>
            Отменить
          </Button>
          <HorizontalSpace size={5} />
          <Button variant={EButtonVariant.SECONDARY} onClick={handleSave}>
            Перенести
          </Button>
        </div>
      }
    >
      <div style={{ padding: 32 }}>
        {filteredClientGroups.map((item) => (
          <div
            className="items-center justify-end w-45 mb-2"
            key={item.clientgroupid}
          >
            <Radio
              id={item.clientgroupid}
              text={item.name || ""}
              name="itemGroup"
              onChange={() => setSelectedRadio(item.clientgroupid)}
              checked={selectedRadio === item.clientgroupid}
              value={item.clientgroupid}
            />
          </div>
        ))}
      </div>
    </BaseLayout>
  );
};
